routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.blogSlider', {
      url: "blogSlider",
      template: `<blog-slider sh-ctrl="shCtrl"></blog-Slider>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/blog/blog-slider/blog-slider.config.js